/* 布局 */
//前台
import Layout from "@views/layout";

const websiteRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "website",
            name: "WEBSITE",
            meta: {
                title: "站点管理",
                sort: 1,
            },
            component: () => import("@views/business/website/index.vue"),
            redirect: {
                name: "WEBSITE_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "WEBSITE_LIST",
                    meta: {
                        title: "站点管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/website/list.vue"),
                },
                                {
                    path: "add",
                    name: "WEBSITE_ADD",
                    meta: {
                        title: "新增站点表",
                        parentPath: '/business/website/list',
                        operate: true,
                    },
                    component: () => import("@views/business/website/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "WEBSITE_EDIT",
                    meta: {
                        title: "编辑站点表",
                        parentPath: '/business/website/list',
                        operate: true,
                    },
                    component: () => import("@views/business/website/form.vue"),
                },
                                        ],
    },


        ],
};

export default websiteRouter;
